<template>
    <div class="container">
        <content-header title="Научные работы наших врачей"/>
        <br>
        <h3>Гастроэнтерология</h3>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box">
                <div class="comment_box">
                    <div class="date">
                        <div class="value">06 СЕН 18</div>
                        <div class="arrow_date"></div>
                    </div>
                </div>
                <router-link :to="{name: 'Урсодезоксихолевая кислота в гастроэнтерологической практике'}">
                    <img src="../../assets/images/staticPages/научная-статья-540x280.jpg" alt="научная-статья"
                         height="249" width="480"/>
                </router-link>
                <h2>
                    <router-link :to="{name: 'Урсодезоксихолевая кислота в гастроэнтерологической практике'}"
                                 class="link"><span>
                    Урсодезоксихолевая кислота в гастроэнтерологической практике
                </span></router-link>
                </h2>
                <p>Научная статья наших врачей Шиндина Татьяна Сергеевна Заведующая отделением Врач гастроэнтеролог
                    Кандидат медицинских наук Кропова Ольга Евгеньевна Врач терапевт Авторы: Минушкин О.Н. 1 , Фролова
                    А.А. 1 , Шиндина Т.С. 2 , Кропова О.Е. 2 , Михайлова Е.В. 3 1 ФГБУ ДПО «Центральная ГМА» УДП РФ,
                    Москва 2 ФГБУ «Поликлиника No 5» УДП РФ, Москва</p>
                <br>
                <p style="font-size: 11px; color: #909090;">
                    <a style="color: #909090; text-decoration: underline"
                       href="http://5-clinic.com/category/гастроэнтерология/">Гастроэнтерология</a>,
                    <a style="color: #909090; text-decoration: underline"
                       href="http://5-clinic.com/category/научная-статья/">Научная статья</a></p>
            </div>
            <div class="box">
                <div class="comment_box">
                    <div class="date">
                        <div class="value">06 СЕН 18</div>
                        <div class="arrow_date"></div>
                    </div>
                </div>
                <router-link :to="{name: 'Ингибиторы протонной помпы в терапии кислотозависимых заболеваний'}">
                    <img src="../../assets/images/staticPages/научная-статья-540x280.jpg" alt="научная-статья"
                         height="249" width="480"/>
                </router-link>
                <h2>
                    <router-link :to="{name: 'Ингибиторы протонной помпы в терапии кислотозависимых заболеваний'}"
                                 class="link"><span>Ингибиторы
                    протонной помпы в терапии кислотозависимых заболеваний</span>
                    </router-link>
                </h2>
                <p>Научная статья наших врачей Шиндина Татьяна Сергеевна Заведующая отделением Врач гастроэнтеролог
                    Кандидат медицинских наук Кропова Ольга Евгеньевна Врач терапевт Авторы: Шиндина Т.С. 1 , Максимов
                    М.Л. 2 , Кропова О.Е. 1 1 ФГБУ «Поликлиника No 5» УДП РФ, Москва 2 КГМА — филиал ФГБОУ ДПО РМАНПО
                    Минздрава России, Казань В 1824 г. У. Праут впервые</p>
                <br>
                <p style="font-size: 11px; color: #909090;">
                    <a style="color: #909090; text-decoration: underline"
                       href="http://5-clinic.com/category/гастроэнтерология/">Гастроэнтерология</a>,
                    <a style="color: #909090; text-decoration: underline"
                       href="http://5-clinic.com/category/научная-статья/">Научная статья</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "medicalResearch",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
    flex-wrap: wrap;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: left;
    width: 460px;
    max-width: 100%;
    margin: 0 30px 10px 0;
}

.box img {
    max-width: 100%;
    height: fit-content;
}

.box:last-child {
    margin-right: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

h2 {
    margin: 24px 0;
    line-height: 120%;
    font-size: 24px;
}

h2 > a {
    color: black !important;
    border: none !important;
}

h2:hover span {
    text-decoration: underline;
}

.comment_box .date .value {
    text-transform: uppercase;
    background-color: #006688;
    color: #fff;
    padding: 10px 13px;
    font-size: 12px;
    width: auto;
}

.comment_box .comments_number {
    width: auto;
    margin-left: 2px;
    background-color: #00b6cc;
    padding: 10px 12px;
    color: #fff;
    font-size: 12px;
}

.comment_box .arrow_date {
    content: '';
    left: 0;
    right: auto;
    display: inline;
    border-color: #006688 transparent;
    visibility: visible;
    position: absolute;
    border-style: solid;
    border-width: 5px 5px 0 0;
}

.comment_box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    position: relative;
}

@media screen and (max-width: 375px) {
    h2 {
        font-size: 20px;
    }
}
</style>
